import React, { useMemo, useState } from "react";
import Button from "components/MaterialButton";
import { ArrowLeft, Loader } from "lucide-react";
import { BASE_URL } from "utils/constant";
import { useAlert } from "components/UI_components/Alert";
import { resolveTransactionFeedback } from "utils/transactionFeedback";
const formatDisplayDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const getMaterialMeta = (material) => {
  if (!material) return "";
  const specification = material?.specification || material?.material_spec || "";
  const subcategory = material?.subcategory || "";
  const brand = material?.brand_name || material?.brand || "";
  return [specification, subcategory, brand].filter(Boolean).join(" | ");
};

export default function RecievedQuoatation({ quotation, rfq, onClose, onBack, onProceedToPO }) {
  const { addAlert } = useAlert();
  const [organisationId, setOrganisationId] = useState(
    JSON.parse(localStorage.getItem("organization"))?.id || null,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleProceedToPO = async () => {
    const accessToken = localStorage.getItem("access");
    setIsSubmitting(true);
    try {
      const response = await fetch(
        `${BASE_URL}/inventory/purchase-orders/create/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            organization: organisationId,
            site: rfq.sites,
            material_request: rfq?.material_request || null,
            rfq: rfq.id,
            vendor: quotation?.vendor || null,
            vendor_name: quotation?.vendor_name || null,
            contact_no: quotation?.phone || null,
            address: quotation?.address || null,
            application_against_quotation: quotation.id,
            order_date: quotation.delivery_date,
            lines: quotation.application_lines.map((line) => ({
              material: line.material,
              mr_lines: line.mr_lines,
              application_lines: line.id,
              rfq_lines: line.rfq_lines,
              quantity: line.quantity,
              unit_price: line.unit_price,
              tax_amount: line.tax_amount,
              total_price: line.total_price,
            })),
          }),
        },
      );

      const data = await response.json().catch(() => null);
      const feedback = resolveTransactionFeedback(data, {
        successMessage: "Purchase Order created successfully",
        errorMessage: "Failed to create Purchase Order",
      });

      if (!response.ok || !feedback.success) {
        addAlert(feedback.message, "error");
        return;
      }

      addAlert(feedback.message, feedback.alertType);
      onClose();
      onProceedToPO();
    } catch (error) {
      console.error("Error creating Purchase Order:", error);
      addAlert(error.message || "Failed to create Purchase Order", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRejectQuotation = async () => {
    const accessToken = localStorage.getItem("access");
    setIsSubmitting(true);
    try {
      const response = await fetch(
        `${BASE_URL}/inventory/applications/${quotation.id}/update/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ status: "rejected" }),
        },
      );

      if (response.ok) {
        addAlert("Quotation rejected successfully", "success");
        onClose();
      }
    } catch (error) {
      console.error("Error rejecting Quotation:", error);
      addAlert("Failed to reject Quotation", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed right-0 top-16 w-1/2 h-[calc(100vh-4rem)] bg-white border-l border-gray-200 shadow-xl z-40 flex flex-col">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <button
            onClick={onBack}
            className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center text-gray-600"
          >
            <ArrowLeft size={18} />
          </button>
          <div className="text-base font-semibold text-gray-900">
            Received Quotation
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="px-4 py-3">
          {/* <div className="grid grid-cols-4 border rounded-md gap-3 mb-3 px-4">
            <div className="p-3 flex items-center">
              <div className="text-sm font-semibold text-gray-900">
                {quotation?.quotation_number || "-"}
              </div>
            </div>
            <div className="p-3">
              <div className="text-xs text-gray-500">Vendor</div>
              <div className="text-sm font-medium text-gray-900">
                {quotation?.vendor_name || "-"}
              </div>
            </div>
            <div className="p-3 text-right">
              <div className="text-xs text-gray-500">Received on</div>
              <div className="text-sm font-medium text-gray-900">
                {formatDisplayDate(
                  quotation?.created_on || new Date().toISOString(),
                )}
              </div>
            </div>
            <div className="p-3 text-right">
              <div className="text-xs text-gray-500">Expected delivery</div>
              <div className="text-sm font-medium text-gray-900">
                {formatDisplayDate(
                  quotation?.delivery_date || new Date().toISOString(),
                )}
              </div>
            </div>
          </div> */}

          <div className="grid grid-cols-5 border rounded-md gap-3 mb-3 px-4">
            <div className="p-3 flex items-center">
              <div className="text-sm font-semibold text-gray-900">
                {quotation?.quotation_number || "-"}
              </div>
            </div>
            <div className="p-3">
              <div className="text-xs text-gray-500">Vendor</div>
              <div className="text-sm font-medium text-gray-900">
                {quotation?.vendor_name || "-"}
              </div>
            </div>
            <div className="p-3 text-right">
              <div className="text-xs text-gray-500">Received on</div>
              <div className="text-sm font-medium text-gray-900">
                {formatDisplayDate(
                  quotation?.created_on || new Date().toISOString(),
                )}
              </div>
            </div>
            <div className="p-3 text-right">
              <div className="text-xs text-gray-500">Expected delivery</div>
              <div className="text-sm font-medium text-gray-900">
                {formatDisplayDate(
                  quotation?.delivery_date || new Date().toISOString(),
                )}
              </div>
            </div>

            {/* ── Status badge ── */}
            <div className="p-3 flex items-center justify-end">
              {quotation.status === "selected" && (
                <span className="px-2 py-0.5 text-[10px] font-medium text-[#00C875] bg-white border border-[#ABEFC6] rounded-full whitespace-nowrap">
                  Selected
                </span>
              )}
              {quotation.status === "rejected" && (
                <span className="px-2 py-0.5 text-[10px] font-medium text-[#D30606] bg-white border border-[#D30606] rounded-full whitespace-nowrap">
                  Rejected
                </span>
              )}
              {quotation.status === "pending_approval" && (
                <span className="px-2 py-0.5 text-[10px] font-medium text-[#F0B41D] bg-white border border-[#FEDF89] rounded-full whitespace-nowrap">
                  Pending
                </span>
              )}
            </div>
          </div>
          <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
            <div className="font-medium text-[#232323]">Content</div>
            <div className="text-sm">Item wise quotation</div>
          </div>

          <div className="space-y-2">
            {quotation?.application_lines?.map((it, index) => (
              <div
                key={it.id}
                className="border border-gray-200 rounded-lg p-3"
              >
                <div className="text-sm text-gray-400 mb-1 pb-1 border-b">
                  Material {index + 1}
                </div>
                <div className="flex items-center justify-between pb-1 border-b">
                  <div>
                    <div className="text-[16px] font-medium text-[#232323]">
                      {it.material_name}
                    </div>
                    {getMaterialMeta(it) && <div className="text-sm text-gray-500">{getMaterialMeta(it)}</div>}
                  </div>
                  <div className="text-right">
                    <div className="text-[16px] font-medium text-[#232323]">
                      {it.quantity} {it.uom}
                    </div>
                    <div className="text-sm text-gray-500">
                      Requested quantity
                    </div>
                  </div>
                </div>
                <div className="mt-2 grid grid-cols-3 gap-3">
                  <div>
                    <div className="text-sm text-gray-500">Unit Price</div>
                    <div className="text-[16px] font-medium text-[#232323]">
                      {it.unit_price}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-sm text-gray-500">Tax Amount</div>
                    <div className="text-[16px] font-medium text-[#232323]">
                      ₹ {it.tax_amount || 0}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-500">Total Price</div>
                    <div className="text-[16px] font-medium text-[#232323]">
                      ₹ {it.total_price}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {quotation.status === "pending_approval" && rfq.status === "OPEN" && (
        <div className="px-4 py-3 border-t border-gray-200 flex items-center gap-4 justify-center">
          <div className="flex items-center">
            <button
              className={`px-4 py-2 text-sm bg-[#FFFFFF] border-1 border-[#3B0069] text-[#3B0069] rounded-md flex flex-row items-center 
                hover:bg-[#3B0069] hover:text-white transition-opacity ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={isSubmitting}
              onClick={handleRejectQuotation}
            >
              {isSubmitting && (
                <Loader size={24} className="animate-spin text-blue-500" />
              )}
              Reject Quotation
            </button>
          </div>
          <div className="flex items-center">
            <button
              className={`px-4 py-2 text-sm bg-[#FFFFFF] border-1 border-[#3B0069] text-[#3B0069] rounded-md flex flex-row items-center 
                hover:bg-[#3B0069] hover:text-white
                ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={isSubmitting}
              onClick={handleProceedToPO}
            >
              {isSubmitting && (
                <Loader size={24} className="animate-spin text-blue-500" />
              )}
              Proceed to PO
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
